module.exports = __webpack_public_path__ + "img/goodstracing_1.9f491b38.png";